module.exports = __webpack_public_path__ + "static/img/sidebar-2.3210362.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidebar-2.jpg
// module id = dSQM
// module chunks = 1